var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import clsx from 'clsx';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
import Typography from '../Typography';
import Points from './Points';
import Switch from '../Switch';
import Box from '../Box';
import ErrorBanner from '../ErrorBanner';
const PointsRedemptionSC = styled.div `
  outline: 0;

  font-family: ${(p) => p.theme.FontFamilyBase};
  font-size: ${(p) => p.theme.SizeFontPointsBase};
  line-height: ${(p) => p.theme.SizeLineHeightPointsBase};
  font-weight: ${(p) => p.theme.ContentFontWeightPointsBase};
  color: ${(p) => p.theme.ColorFontTypographyBase};

  padding: 1rem;
  width: 22.5rem;
  max-width: 100%;

  ._ndsRedemption_switch label {
    margin: 0;
  }
  ._ndsRedemption_points {
    width: calc(100% - 7rem);
    min-width: 0;
  }
`;
const flexBox = `
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: center;
`;
const FlexBox = styled(Box) `
  ${flexBox}
`;
const LpBox = styled(Box) `
  ${flexBox}
  padding-top: ${(props) => (props.isLabel ? '0.75rem' : '0rem')};
`;
const DeductionAmount = styled(Typography) `
  color: ${(props) => props.theme.ColorBaseBrandSecondary500};
`;
const pulse = keyframes `
0% {
    opacity: 0.1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.1;
  }
`;
const Skeleton = styled.div `
  background-color: grey;
  border-radius: 0.25rem;
  animation-timing-function: ease-out;
  animation-iteration-count: infinite;
  animation-duration: 1.5s;
  width: 14.25rem;
  height: 1.5rem;
  animation-name: ${pulse};
`;
const PointsRedemption = (props) => {
    const { title, deductionAmount, pointsLabel, disabled, pointsIcon, errorIcon, errorText, loading, errorActionLabel, onErrorAction, checked, hasToggle, onToggleChange, className: classNameProp, layout, forwardedRef } = props, others = __rest(props, ["title", "deductionAmount", "pointsLabel", "disabled", "pointsIcon", "errorIcon", "errorText", "loading", "errorActionLabel", "onErrorAction", "checked", "hasToggle", "onToggleChange", "className", "layout", "forwardedRef"]);
    const isInline = layout === 'inline';
    const classes = clsx('_ndsRedemption', classNameProp);
    return (React.createElement(PointsRedemptionSC, Object.assign({ ref: forwardedRef, className: classes }, others),
        !isInline && (React.createElement(FlexBox, null,
            React.createElement(Typography, { variant: "h6" }, title),
            hasToggle && (React.createElement(Switch, { size: "s", checked: checked, disabled: disabled, className: "_ndsRedemption_switch", onChange: onToggleChange })))),
        React.createElement(LpBox, { isLabel: Boolean(!isInline && pointsLabel) },
            pointsLabel && (React.createElement(Points, { pointsIcon: pointsIcon, label: pointsLabel, disabled: disabled, className: "_ndsRedemption_points" })),
            (checked || !hasToggle) && deductionAmount && !isInline && (React.createElement(DeductionAmount, { variant: "subhead1" },
                "-",
                deductionAmount)),
            isInline && loading && React.createElement(Skeleton, { "data-testid": "loading" }),
            isInline && hasToggle && (React.createElement(Switch, { size: "s", checked: checked, disabled: disabled, className: "_ndsRedemption_switch", onChange: onToggleChange }))),
        disabled && (React.createElement(Box, { mt: 1 },
            loading && !isInline && React.createElement(Skeleton, null),
            errorText && !loading && (React.createElement(ErrorBanner, { label: errorText, action: errorActionLabel, attentionLevel: "medium", icon: errorIcon, onAction: onErrorAction, fullWidth: true }))))));
};
PointsRedemption.propTypes = {
    title: PropTypes.string,
    deductionAmount: PropTypes.string,
    pointsIcon: PropTypes.element,
    errorIcon: PropTypes.element,
    pointsLabel: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
        PropTypes.string
    ]),
    className: PropTypes.string,
    errorText: PropTypes.string,
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    errorActionLabel: PropTypes.string,
    onErrorAction: PropTypes.func,
    loading: PropTypes.bool,
    hasToggle: PropTypes.bool,
    onToggleChange: PropTypes.func,
    layout: PropTypes.oneOf(['standard', 'inline']),
    forwardedRef: PropTypes.any
};
PointsRedemption.defaultProps = {
    title: null,
    deductionAmount: null,
    pointsLabel: null,
    hasToggle: true,
    checked: false,
    pointsIcon: undefined,
    errorIcon: undefined,
    className: undefined,
    disabled: false,
    errorText: null,
    errorActionLabel: undefined,
    onErrorAction: null,
    onToggleChange: null,
    loading: false,
    layout: 'standard',
    forwardedRef: null
};
export { PointsRedemption as PointsRedemptionRootComp };
export default withForwardedRef(PointsRedemption);
//# sourceMappingURL=PointsRedemption.js.map